<template>
<div class="page-catalog">
  <div class="catalog-items-wrapper static-container">
    <header class="page-catalog__header">
      <h1 class="page-heading" :class="{ 'opacity-30': promotionsAreChecking }">
        {{ title }}
        &nbsp;<i v-if="promotionsAreChecking" class="fad fa-spinner-third fa-spin"></i>
      </h1>
      <p v-if="!maxQuantity">
        <a href="javascript:;" @click="openCart" class="text-primary-dark">Вернуться в корзину</a>
      </p>
    </header>
    <section class="catalog-items-list-container">
      <div class="catalog-products-list-wrapper">
        <products-list v-if="hasProducts"
                       source="promotion_rewards_page"
                       :products="products"
                       :promotion-id="promotionId"
                       :reward-id="rewardId"
        />
        <div v-else-if="noProducts" class="empty-products-list">
          <h2 class="empty-products-list-heading">Ничего не найдено</h2>
          <p>По вашему запросу ничего не найдено.</p>
        </div>
        <div v-else-if="requestFailed" class="empty-products-list">
          <h2 class="empty-products-list-heading">Произошла ошибка</h2>
          <p>Во время загрузки товаров произошла ошибка.</p>
          <div>
            <button type="button" class="btn btn-primary rounded" :disabled="productsAreLoading" @click="loadProducts">
              Повторить попытку
            </button>
          </div>
        </div>

        <transition name="opacity">
          <div v-if="productsAreLoading" class="page-catalog__preloader-wrapper">
            <preloader class="page-catalog__preloader"/>
          </div>
        </transition>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import ProductsList from '@/components/products/ProductsList'
import Preloader from '@/components/preloaders/Preloader'
import { mapGetters } from 'vuex'
import config from '@/config'
import axios from '@/zenky'
import pluralize from '@/helpers/pluralize'

export default {
  props: {
    promotionId: {
      type: String,
      required: true,
    },

    rewardId: {
      type: String,
      required: true,
    },
  },

  components: {
    Preloader,
    ProductsList,
  },

  mounted() {
    this.loadProducts()
  },

  computed: {
    ...mapGetters({
      cityId: 'store/activeCityId',
      rewardSelector: 'order/rewardSelector',
      promotionsAreChecking: 'order/promotionsAreChecking',
    }),

    context() {
      if (!this.$route.query) {
        return null
      }

      const id = this.$route.query.context_id || null
      const type = this.$route.query.context_type || null

      if (!id || !type) {
        return null
      }

      return { id, type }
    },

    productsQuery() {
      const query = {
        count: 100,
        page: 1,
        with: config.includes.productsList,
        city_id: this.cityId,
        promotion_reward: 'all',
      }

      if (!this.context) {
        return query
      }

      query.context_type = this.context.type
      query.context_id = this.context.id

      return query
    },

    hasProducts() {
      return this.productsWereLoaded && this.products.length > 0
    },

    noProducts() {
      return this.productsWereLoaded && !this.products.length
    },

    maxQuantity() {
      if (!this.rewardSelector || !this.rewardSelector.max_quantity) {
        return 0
      }

      return this.rewardSelector.max_quantity
    },

    title() {
      if (!this.maxQuantity) {
        return 'Вы выбрали все подарки'
      }

      return pluralize(this.maxQuantity, [
          `Вам доступен ещё ${this.maxQuantity} подарок`,
          `Вам доступно ещё ${this.maxQuantity} подарка`,
          `Вам доступно ещё ${this.maxQuantity} подарков`,
      ], false)
    }
  },

  methods: {
    loadProducts() {
      if (this.productsAreLoading) {
        return
      }

      this.productsAreLoading = true

      axios.get('products', { params: this.productsQuery })
        .then(({ data }) => {
          this.products = data.data
          this.productsAreLoading = false
          this.requestFailed = false
          this.productsWereLoaded = true
        })
        .catch(err => {
          console.error('Unable to load products', { err })

          this.productsAreLoading = false
          this.requestFailed = true
        })
    },

    openCart() {
      this.$store.commit('ui/toggleCartModal')
    },
  },

  data() {
    return {
      open: false,
      anchorVisible: true,
      products: [],
      productsAreLoading: false,
      productsWereLoaded: false,
      requestFailed: false,
    }
  }
}
</script>
